module.exports = "/assets/2693c1c25e603ad59bd759cb2950b3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KQ.png
// module id = 2678
// module chunks = 0